import BaseModel from "./BaseModel";
import type Device from "./Device";
import { copyAllProperties } from "./utils";
import ObjectFactory from "./ObjectFactory";

export class KnxSceneBehaviour {
  name: string = "";
  type: string = "";
  label: string = "";
  parameterId: string = "";
  instanceId: string = "";
  moduleId: string = "";
  data: any;

  static getOptions(
    device: Device,
    knxSceneBehaviour: KnxSceneBehaviour,
  ): Array<{ value: string; label: string }> | undefined {
    if (knxSceneBehaviour?.data) {
      const item = device.template?.knxProductData.deref(knxSceneBehaviour.data);

      const ParameterTypeId = item?.a.ParameterType;

      const parmeterType = device.template?.knxProductData?.globalMap.get(ParameterTypeId);

      const pameterRestriction = parmeterType?.TR || parmeterType?.TypeRestriction;

      const pameterEnumerations = pameterRestriction ? pameterRestriction[0] || pameterRestriction : undefined;

      if (pameterEnumerations) {
        const res = new Array<{ value: string; label: string }>();

        for (let i in pameterEnumerations.items) {
          const pameterEnumeration = pameterEnumerations.items[i];

          const opt = pameterEnumeration;
          const optValue = opt.a.Value;
          var optText = opt.a.Text;

          const optText1 = device.template?.knxProductData.languageMapping.getTranslation(
            pameterEnumeration.a.Id,
            "Text",
          );
          if (optText1) {
            optText = optText1;
          }

          res.push({ value: optValue, label: optText });
        }
        return res;
      }
    }

    return undefined;
  }

  static getCurrentValueDisplay(device: Device, knxSceneBehaviour: KnxSceneBehaviour) {
    let currentValue = device.knxInstanceData.getValue(knxSceneBehaviour.parameterId, knxSceneBehaviour.instanceId);

    if (currentValue == undefined) {
      currentValue = device.template?.knxProductData.getDefaultValueForParameter(
        knxSceneBehaviour.data,
        knxSceneBehaviour.instanceId,
      );
    }

    const options = KnxSceneBehaviour.getOptions(device, knxSceneBehaviour);

    let res = options?.find((item: any) => item.value == currentValue)?.label;
    if (!res) {
      res = currentValue;
    }

    return res;
  }
}

ObjectFactory.registerClass("KnxSceneInfo", (data?: any, parent?: BaseModel) => {
  return new KnxSceneInfo(data, parent);
});

export class KnxSceneInfo extends BaseModel {
  public get className(): string {
    return "KnxSceneInfo"; // no itx
  }

  constructor(data?: any, parent?: BaseModel) {
    super({ ...data, propertyId: "sci" }, parent); // no itx
    copyAllProperties(data, this);
  }

  getPersistentProperties(): string[] {
    return [
      "deviceId", // no itx
      "instanceId", // no itx
      "numberId", // no itx
      "activateId", // no itx
      "behaviours", // no itx
      ...super.getPersistentProperties(),
    ];
  }

  deviceId: string | undefined;
  get device(): Device | undefined {
    return this.state.objectRegistry.getObject(this.deviceId);
  }

  set device(newValue: Device | undefined) {
    this.deviceId = newValue?.id;
  }

  instanceId: string = "";
  moduleId: string = "";

  /// Scene Number
  numberId?: string;

  /// Scene aktivieren
  activateId?: string;

  /// Scene Behaviour zZ noch Org ProductData ....
  behaviours = new Array<KnxSceneBehaviour>();
}

export class KnxSceneInfos {
  channelSceneEnablingId = "";
  channelSceneEnablingInstanceId = "";
  channelSceneEnablingModuleId = "";

  sceneComObjectNumber = -1;
  knxSceneInfos = new Array<KnxSceneInfo>();

  get empty(): boolean {
    return this.channelSceneEnablingId === "" && this.knxSceneInfos.length == 0;
  }
}
